import styled from 'styled-components';

const BurgerMenuStyle = styled.div`
	--burgerMenuPadTB: var(--sp5x);
	--leftTopWrapperItemsGap: var(--sp1x);
	--burgerMenuItemsGap: var(--sp4x);
	--portfolioItemsWrapperPadTop: var(--sp4x);
	--portfolioItemRowGap: var(--sp2x);
	--portfolioItemColumnGap: var(--sp3x);
	--portfolioItemsEmptyWidth: 14.1%;
	--portfolioItemsWidth: calc(100% - var(--portfolioItemsEmptyWidth));
	--portfolioItemWidth: calc((100% / 3) - ((2 * var(--portfolioItemColumnGap) / 3)));

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	padding: var(--burgerMenuPadTB) 0;
	background-color: var(--black1000);
	z-index: 999;

	transform: translateY(-100%);
	will-change: transform;
	transition: var(--globalTransformVariables);

	/* //! Burger open-close styles */
	&.active {
		transform: translateY(0);
	}

	.burger-left-inner-block {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		gap: var(--sp4x);
	}

	.block1 {
		display: flex;
		justify-content: space-between;
		gap: var(--sp2x);
	}

	.burger-phone-text,
	.burger-email-text,
	.explore-more {
		text-decoration-line: underline;
		text-decoration-style: solid;
		text-decoration-skip-ink: auto;
		text-decoration-thickness: auto;
		text-underline-offset: auto;
		text-underline-position: from-font;
	}

	.left-bottom-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--leftTopWrapperItemsGap);

		a {
			width: fit-content;
		}
	}

	.burger-portfolio-items-wrapper {
		display: flex;
		padding-top: var(--portfolioItemsWrapperPadTop);
	}

	.portfolio-items-wrapper {
		width: var(--portfolioItemsWidth);
		display: flex;
		flex-wrap: wrap;
		row-gap: var(--portfolioItemRowGap);
		column-gap: var(--portfolioItemColumnGap);
	}

	.portfolio-items-left-block {
		width: var(--portfolioItemsEmptyWidth);
	}

	.portfolio-item-block {
		width: var(--portfolioItemWidth);

		a {
			width: fit-content;
			display: block;
		}
	}

	.burger-right-inner-block {
		display: flex;
		flex-direction: column;
		gap: var(--burgerMenuItemsGap);
	}

	#collapse-title {
		width: fit-content;
	}

	.burger-menu-item {
		text-transform: uppercase;
	}

	.block1,
	.block3,
	.block4,
	.block5 {
		a {
			display: block;
			width: fit-content;
		}
	}

	/* //! Burger Menu Item Active Styles */
	.btn-hover-relative-block,
	.portfolio-item-block {
		&.active {
			pointer-events: none;
			cursor: default;
			opacity: 0.5;
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--burgerMenuPadTB: var(--sp4x);
		--burgerMenuItemsGap: var(--sp3x);
		--portfolioItemsWrapperPadTop: var(--sp2x);
		--portfolioItemRowGap: var(--sp2x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 14.6%;
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--burgerMenuPadTB: var(--sp3x);
		--burgerMenuItemsGap: var(--sp3x);
		--portfolioItemsWrapperPadTop: var(--sp2x);
		--portfolioItemRowGap: var(--sp1-5x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 14.9%;
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--burgerMenuPadTB: var(--sp3x);
		--leftTopWrapperItemsGap: var(--sp0-5x);
		--burgerMenuItemsGap: var(--sp3x);
		--portfolioItemsWrapperPadTop: var(--sp2x);
		--portfolioItemRowGap: var(--sp1-5x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 14.5%;
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--burgerMenuPadTB: var(--sp3x);
		--burgerMenuItemsGap: var(--sp2-5x);
		--portfolioItemsWrapperPadTop: var(--sp2x);
		--portfolioItemRowGap: var(--sp1-5x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 14.7%;
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--burgerMenuPadTB: var(--sp3x);
		--burgerMenuItemsGap: var(--sp2x);
		--portfolioItemsWrapperPadTop: var(--sp1x);
		--portfolioItemRowGap: var(--sp1-5x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 14.6%;
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--burgerMenuPadTB: var(--sp2x);
		--burgerMenuItemsGap: var(--sp2x);
		--portfolioItemsWrapperPadTop: var(--sp1x);
		--portfolioItemRowGap: var(--sp1x);
		--portfolioItemColumnGap: var(--sp3x);
		--portfolioItemsEmptyWidth: 0%;
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--burgerMenuPadTB: var(--sp1-5x);
		--burgerMenuItemsGap: var(--sp4x);
		--portfolioItemsWrapperPadTop: var(--sp2x);
		--portfolioItemRowGap: var(--sp1-5x);
		--portfolioItemColumnGap: var(--sp1-5x);
		--portfolioItemWidth: calc((100% / 2) - ((1 * var(--portfolioItemColumnGap) / 2)));

		height: 100dvh;

		.is-mobile-screen {
			display: none !important;
		}

		.burger-menu-inner-wrapper {
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		.section-container {
			display: flex;
			flex-direction: column;
			flex: 1;

			> .row {
				display: flex;
				flex-direction: column;
				flex: 1;
			}
		}

		.burger-right-block {
			display: flex;
			flex-direction: column;
			flex: 1;
			margin-top: var(--sp3-5x);
		}

		.burger-right-inner-block {
			display: flex;
			flex-direction: column;
			flex: 1;

			overflow-x: hidden;
			overflow-y: auto;
			max-height: calc(100vh - var(--burgerMenuPadTB) * 2 - var(--sp9x) - 52px);

			&::-webkit-scrollbar {
				display: none;
			}

			-ms-overflow-style: none;
			scrollbar-width: none;
		}

		.left-bottom-wrapper {
			margin-top: var(--sp3x);
			justify-content: flex-end;
		}

		.is-mobile-version {
			display: grid;
			grid-template-columns: 1fr auto 1fr;
			align-items: center;
			align-self: stretch;
			gap: var(--sp3x);
			justify-content: unset;
			height: unset;
		}

		.burger-svg-block {
			display: flex;

			a {
				display: flex;
			}

			svg {
				height: var(--sp2-5x);
			}
		}

		.burger-instagram-icon-block {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			a {
				display: flex;
			}

			.instagram-icon {
				font-size: var(--sp2x);
				color: var(--white1000);
			}
		}

		/* //! External styles */
		.burger-menu-item {
			font-size: var(--sp3x);
		}
	}
`;

export default BurgerMenuStyle;
